import Title from "./Title";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import apiService from "../../Services/apiService";
import Loading from "../General/Loading";
import PopupGlobel from "../../PopModal/PopupGlobel";
const MngAccessMobiles = () => {
  const [loading, setLoading] = useState(false);
  const [navParams] = useSearchParams();
  const [idUpdate, setIdUpdate] = useState(""); 
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [status, setStatus] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isShowPopAdd, setIsShowPopAdd] = useState(false);
  const [errName, setErrName] = useState("");
  const [errMobile, setErrMobile] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const no = navParams.get("no");
    if (no != null) { 
      setIdUpdate(no);
      fetchData(no);
    }
  }, []);

  const fetchData = async (no: any) => {
    try {
      setLoading(true);
      const result = await apiService.fetchGetData("api/GetAccessMobileByNo", {
        no: no,
      });
     
      if (result[0]) {
        setName(result[0].name);
        setMobile(result[0].mobile);
        setStatus(result[0].status);
      }
    } catch (error) {
      console.error(error);
    }
       setLoading(false);
  };
  const addData = async () => {
    try {
      setLoading(true);
      debugger;
      const result =
        idUpdate != null && idUpdate !== ""
          ? await apiService.fetchData("api/AddMobile", {
              eaccessId: idUpdate,
              name: name,
              mobile: mobile,
              status: status
            })
          : await apiService.fetchData("api/AddMobile", {
              name: name,
              mobile: mobile,
              status: status
            });
      if (result.isOk) {
        setSuccess("✅" + result.errAr);
      } else setError("❌" + result.errAr);
      setIsShowPopAdd(false);
      setLoading(false);
      return result;
    } catch (error) {
      setError("❌" + error);
      setIsShowPopAdd(false);
      setLoading(false);
      return null;
    }
  };
  const handleSubmit = () => {
    if (validateForm()) {
      addData();
    } else {
      setError("راجع مدخلات الحقول");
    }
  };
  const isSaudiMobile= (phone:string) => {
  return /^(?:05|9665|\+9665)\d{8}$/.test(phone);
};
  const validateForm = () => {
    let isValidate = true;
    if (name.trim() === "") {
      isValidate = false;
      setErrName("إدخل الاسم");
    } else {
      setErrName("");
    }
    if (mobile.trim() === "") {
      isValidate = false;
      setErrMobile("إدخل رقم الجوال  ");
    } else {
        if (isSaudiMobile(mobile.trim())!==true) {
      isValidate = false;
      setErrMobile("صيغة رقم الجوال غير صحيح");
    } else {
      setErrMobile("");
    }
    }
    return isValidate;
  };
  return (
    <>
      {loading && <Loading />}
      {isShowPopAdd && (
        <PopupGlobel
          approveAction={() => handleSubmit()}
          cancelAction={() => {
            setIsShowPopAdd(false);
          }}
          btnApproveTitle="حفظ"
          btnCancelTitle="الغاء"
          title="تاكيد الحفظ"
          popupType={1}
        >
          <p>هل انت متاكد من حفظ البيانات؟ </p>
        </PopupGlobel>
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">
          <Title
            pageName=" إدارة بيانات الوصول الى الخريطة"
            pageDesc=""
            isSearch={false}
            isAdd={true}
            btnIcon="filter_list"
            addEvent={() => navigate("/admin/listMobiles")}
            AddText="عرض قائمة الجوالات"
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-12 flex flex-col gap-8">
              {/* Profile Settings */}
              <section
                className="bg-surface-container-lowest rounded-2xl p-8 shadow-sm"
                id="profile"
              >
                {error && (
                  <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                    {success}
                  </div>
                )}
                <div className="flex items-center gap-4 mb-8 pb-4 border-b border-surface-container-highest">
                  <span className="material-symbols-outlined text-[28px] text-primary">
                    person
                  </span>
                  <h2 className="font-headline-md text-headline-md text-on-surface">
                    إدارة بيانات الوصول الى الخرائط العامة
                  </h2>
                </div>
                <div className="flex flex-col md:flex-row gap-8">
                  <div className="w-full md:w-2/3 flex flex-col gap-6">
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        اسم المستخدم
                        {errName !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errName}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        رقم الجوال 
                        {errMobile !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errMobile}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="tel"
                         placeholder="05x xxx xxxx"  
                        maxLength={12}
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                      />
                    </div>
  <div className="flex flex-col gap-2">
                      <label className="text-xs font-semibold text-on-surface-variant flex items-center gap-1">
                        الحالة
                      </label>
                      <div className="relative">
                        <select
                          value={String(status)}
                          onChange={(e) => setStatus(e.target.value.toString()==="true"?true:false)}
                          className="w-full bg-surface-container-low border border-outline-variant/40 rounded-xl px-3 py-2 text-body-sm text-on-surface outline-none focus:border-vibrant-orange transition-all appearance-none cursor-pointer pr-3 pl-8"
                        >
                          <option value="true"> نشط</option>
                          <option value="false"> مقفل</option>
                        </select>
                        <span className="material-symbols-outlined absolute left-2.5 top-1/2 -translate-y-1/2 text-on-surface-variant text-base pointer-events-none">
                          expand_more
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-end mt-2">
                      <button
                        onClick={() => {
                          setName("");
                          setMobile("");
                          setIdUpdate("");
                          setError("");
                          setSuccess("");
                          setIdUpdate("");
                          navigate("/admin/mngMobiles");
                        }}
                        className="rounded-full shadow-sm bg-surface text-on-surface hover:bg-surface/90  font-label-md px-6 py-2  transition-al"
                      >
                        <span className=""> جديد</span>
                      </button>
                      <button
                        style={{ marginRight: "2px" }}
                        onClick={() => {
                          if (validateForm()) {
                            setIsShowPopAdd(true);
                          } else {
                            setError("راجع مدخلات الحقول");
                          }
                        }}
                        className="rounded-full shadow-sm bg-primary text-on-primary hover:bg-primary/90  font-label-md px-6 py-2  transition-al"
                      >
                        حفظ
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MngAccessMobiles;
